/* eslint-disable */
import * as types from './types';
import router from "../../../router";
import axios from 'axios';



const actions = {
  listConfigurations({commit}){
    const AuthStr = "Bearer " + this.state.auth.user.token;
    axios.get( process.env.API_ENDPOINT + 'configuration',
      { headers: {Authorization: AuthStr} }
    ).then(response => {
      commit(types.LIST_CONFIGURATIONS_SUCCESS, response.data )
    })
    .catch((error) => {
      console.log(error);
    });
  },
  getConfiguration({commit}, configurationHash ){
    return new Promise((resolve, reject) => {
      const AuthStr = "Bearer " + this.state.auth.user.token;

      axios.get( process.env.API_ENDPOINT + 'configuration/' + configurationHash,
        { headers: {Authorization: AuthStr} }
      ).then(response => {
        commit(types.GET_CONFIGURATION_SUCCESS, response.data );
        resolve();
      })
        .catch((error) => {
          console.log(error);
          reject();
        });
    });
  },
  saveConfiguration({commit}, configuration ){
    console.log(configuration);
    const AuthStr = "Bearer " + this.state.auth.user.token;
    let url = '';
    if (typeof(configuration.configuration_hash) != "undefined"){
      url = process.env.API_ENDPOINT + 'configuration/' + configuration.configuration_hash;
    }else{
      url = process.env.API_ENDPOINT + 'configuration';
    }
    axios.post( url, configuration, { headers: {Authorization: AuthStr} }
    ).then(response => {
      commit(types.GET_CONFIGURATION_SUCCESS, response.data );
    })
      .catch((error) => {
        console.log(error);
      });
  },
  createConfiguration({commit}, configuration ){
    const AuthStr = "Bearer " + this.state.auth.user.token;
    axios.post( process.env.API_ENDPOINT + 'configuration', configuration,
      { headers: {Authorization: AuthStr} }
    ).then(response => {
      router.push('/dashboard');
    })
      .catch((error) => {
        console.log(error);
      });
  },
  updateConfiguration({commit}, configuration ){
    const AuthStr = "Bearer " + this.state.auth.user.token;
    axios.post( process.env.API_ENDPOINT + 'configuration/' + configuration.configurationHash,
      configuration, { headers: {Authorization: AuthStr} }
    ).then(response => {
      commit(types.GET_CONFIGURATION_SUCCESS, response.data );
      router.push('/dashboard');
    })
      .catch((error) => {
        console.log(error);
      });
  },
  deleteConfiguration({commit, dispatch}, configuration_hash ){
    const AuthStr = "Bearer " + this.state.auth.user.token;
    axios.delete( process.env.API_ENDPOINT + 'configuration/' + configuration_hash,
      { headers: {Authorization: AuthStr} }
    ).then(response => {
      dispatch('listConfigurations');
    })
      .catch((error) => {
        console.log(error);
      });
  },
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/modules/configuration/actions.js